import "./styles.scss";

import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import IconsLingo from "../../../../components/IconsLingo/iconsLingo";

const RenderHtml = ({ customLang }) => {
  const { t, i18n } = useTranslation();
  const {
    methodologyLingoEN,
    methodologyLingoES,
    methodologyLingoPT,
    methodologyLingoFR,
    methodologyLingoENInterview,
    methodologyLingoESInterview,
    methodologyLingoPTInterview,
    methodologyLingoFRInterview,
  } = useSelector((state) => state.contentReducer);

  const htmlContent = {
    en: methodologyLingoEN.content,
    es: methodologyLingoES.content,
    pt: methodologyLingoPT.content,
    fr: methodologyLingoFR.content,
    interview_en: methodologyLingoENInterview.content,
    interview_es: methodologyLingoESInterview.content,
    interview_pt: methodologyLingoPTInterview.content,
    interview_fr: methodologyLingoFRInterview.content,
  };

  const currentLanguage = `${customLang === false ? "interview_" : ""}${i18n.language ?? "en"}`;

  console.log(htmlContent[currentLanguage]);

  return (
    <div className="renderHtml">
      <div className="headerHtml blue">
        <h3>{t("METHODOLOGY")}</h3>
        <div>
          <IconsLingo width="58" height="24" name={"polygon"} fill={"rgb(61, 168, 254)"} />
        </div>
      </div>
      <div className="contentHtml" dangerouslySetInnerHTML={{ __html: htmlContent[currentLanguage] }} />
    </div>
  );
};

export default RenderHtml;
